import React from 'react';

import withCard from './WithCard';
import ShortText from '../../../Types/Components/ShortText';

const ShortTextCard = (props) => {
  return <ShortText {...props} />
}

export default withCard(ShortTextCard);